import {Close} from '@mui/icons-material'
import {Grid, Modal, Box, IconButton, Tooltip} from '@mui/material'
import React from 'react'
import WbTextField from '../../../components/common/WbTextField'
import EmojiPicker, {Emoji} from 'emoji-picker-react'
import WbButton from '../../../components/common/WbButton'

export default function ChangeCheckInQuestion({
  onClose,
  checkInQuestion,
  setCheckInQuestion,
}) {
  const [showEmojiPicker, setShowEmojiPicker] = React.useState(false)
  const [index, setIndex] = React.useState(0)

  return (
    <Modal
      open={true}
      onClose={() => {
        onClose()
      }}
      style={{
        background: 'transparent',
        backdropFilter: 'blur(5px)',
      }}
    >
      <Box
        sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: 600,
          bgcolor: 'background.paper',
          boxShadow: 24,
          p: 4,
        }}
      >
        <Modal
          open={showEmojiPicker}
          onClose={() => {
            setShowEmojiPicker(false)
          }}
          style={{
            background: 'transparent',
            backdropFilter: 'blur(5px)',
          }}
        >
          <EmojiPicker
            skinTonesDisabled
            style={{
              zIndex: 9999,
              top: '10%',
              left: '40%',
            }}
            onEmojiClick={e => {
              const newOptions = [...checkInQuestion.options]
              newOptions[index].emoji = e.unified
              setCheckInQuestion({
                ...checkInQuestion,
                options: newOptions,
              })
              setShowEmojiPicker(false)
            }}
            emojiStyle={{width: '100%', height: '100%'}}
            size={24}
          />
        </Modal>
        <Grid container spacing={2}>
          <Grid item xs={6}>
            <h2>Change Check In Question</h2>
          </Grid>
          <Grid item xs={6}>
            <IconButton onClick={onClose} sx={{float: 'right'}}>
              <Close sx={{color: '#000'}} />
            </IconButton>
          </Grid>
          <Grid item xs={12}>
            <div className="info-panel">
              You can change the check in question here. The question will be
              used in all check ins.
            </div>
          </Grid>
          <Grid item xs={12}>
            <WbTextField
              label={'Check In Question'}
              fullWidth
              value={checkInQuestion.question}
              onChange={e => {
                setCheckInQuestion({
                  ...checkInQuestion,
                  question: e.target.value,
                })
              }}
            />
          </Grid>
          {checkInQuestion.options.map((option, idx) => (
            <>
              <Grid item xs={8}>
                <WbTextField
                  key={idx}
                  label={`Answer Option ${idx + 1}`}
                  fullWidth
                  value={option.label}
                  onChange={e => {
                    const newOptions = [...checkInQuestion.options]
                    newOptions[idx].label = e.target.value
                    setCheckInQuestion({
                      ...checkInQuestion,
                      options: newOptions,
                    })
                  }}
                />
              </Grid>
              <Grid item xs={2}>
                <WbTextField
                  label={'Num Value'}
                  type="number"
                  fullWidth
                  value={option.numValue}
                  onChange={e => {
                    const newOptions = [...checkInQuestion.options]
                    newOptions[idx].numValue = e.target.value
                    setCheckInQuestion({
                      ...checkInQuestion,
                      options: newOptions,
                    })
                  }}
                />
              </Grid>
              <Grid
                item
                xs={2}
                onClick={e => {
                  setShowEmojiPicker(!showEmojiPicker)
                  setIndex(idx)
                }}
              >
                <Emoji unified={option?.emoji} />
              </Grid>
            </>
          ))}
          <Grid item xs={12} sx={{textAlign: 'right'}}>
            <WbButton CustomButtonText={'Close'} onClick={w => onClose()} />
          </Grid>
        </Grid>
      </Box>
    </Modal>
  )
}
